// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

export const AVATARS = [
  {
    name: "bear",
    src: "/img/bear.png",
  },
  {
    name: "bird",
    src: "/img/bird.png",
  },
  {
    name: "bird2",
    src: "/img/bird2.png",
  },
  {
    name: "dog",
    src: "/img/dog.png",
  },
  {
    name: "giraffe",
    src: "/img/giraffe.png",
  },
  {
    name: "hedgehog",
    src: "/img/hedgehog.png",
  },
  {
    name: "hippo",
    src: "/img/hippo.png",
  },
];

export const STICKERS = [
  {
    name: "cute",
    src: "/img/sticker-1.png",
  },
  {
    name: "angry",
    src: "/img/sticker-2.png",
  },
  {
    name: "sad",
    src: "/img/sticker-3.png",
  },
  {
    name: "happy",
    src: "/img/sticker-4.png",
  },
  {
    name: "surprised",
    src: "/img/sticker-5.png",
  },
  {
    name: "cool",
    src: "/img/sticker-6.png",
  },
  {
    name: "love",
    src: "/img/sticker-7.png",
  },
  {
    name: "rocket",
    src: "/img/sticker-8.png",
  },
  {
    name: "confetti",
    src: "/img/sticker-9.png",
  },
  {
    name: "camera",
    src: "/img/sticker-10.png",
  },
];
